import { createRoot } from 'react-dom/client';
import { createHashRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import './index.css';
import BaseLayout from './layout/base';
import AppBootstrap from './bootstrap';
import NotFoundPage from '~pages/NotFound';
import ErrorPage from '~pages/Error';
import AppSetup from './setup';
import HealthDashboardPage from '~pages/HealthDashboard';

const router = createHashRouter(
  createRoutesFromElements(
    <Route element={<AppBootstrap />} errorElement={<ErrorPage />}>
      <Route element={<AppSetup />}>
        <Route element={<BaseLayout />}>
          <Route path="" element={<HealthDashboardPage />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Route>
  )
);

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  <RouterProvider router={router} />
  // </StrictMode>
);
